import { isMobileAtom, useRecoil } from '@orcar/common-d2c';
import MobileInsuranceInfoImg from '@/assets/img/img_family-insurance-info-mobile.svg';
import ContractConditionInfo from './ContractConditionInfo';
import * as S from '../styles';

const InsuranceInfo = () => {
  const { recoilValue: isMobile } = useRecoil(isMobileAtom);
  return (
    <>
      {isMobile ? (
        <img
          src={MobileInsuranceInfoImg}
          width='100%'
          alt='모바일버전 보험안내 이미지'
          style={{ maxWidth: '350px' }}
        />
      ) : (
        <S.Wrapper isMobile={isMobile}>
          <ContractConditionInfo />
          <S.Title type='page'>보험 규정</S.Title>
          <S.Section type='main'>
            <S.Title type='reservation'>[종합 보험]</S.Title>
            <S.TableWrapper>
              <S.Table width='690px'>
                <thead>
                  <S.TableRow height='51px'>
                    <S.Th>대인</S.Th>
                    <S.Th>대물</S.Th>
                    <S.Th>자손</S.Th>
                  </S.TableRow>
                </thead>
                <tbody>
                  <S.TableRow height='51px'>
                    <S.Td>무한</S.Td>
                    <S.Td>2,000만원</S.Td>
                    <S.Td>1,500만원</S.Td>
                  </S.TableRow>
                </tbody>
              </S.Table>
            </S.TableWrapper>

            <S.Section type='text'>
              <S.Text type='main' color='#7E7E7E'>
                ※ 종합보험 한도 초과시 초과금은 임차인이 부담합니다.
                <br />※ 계약서에 등록된 임차인(제1운전자)과 제2운전자는
                자손보험으로 처리됩니다. <br />
              </S.Text>
            </S.Section>

            <S.Section type='text'>
              <S.Text type='main'>
                ※ 종합보험 대인, 대물, 자손 접수 시 고객 부담금 안내
                <br />- 대인 접수 시 : 1인 기준 고객 부담 30만원 <br />- 대물
                접수 시 : 1건 기준 고객 부담 50만원
                <br /> - 자손 접수 시 : 1인 기준 고객 부담 30만원
              </S.Text>
            </S.Section>
          </S.Section>
          <S.Section type='main'>
            <S.Title type='reservation'>
              [차량 손해 면책(자차보험) 계약 제도]
            </S.Title>
            <S.Section type='text'>
              <S.Text type='main'>
                • 임차인은 차량 사고 발생 시 손해를 줄이기 위해
                자기차량손해보험을 사전에 개별적으로 가입해서 이용할 수 있으며,
                또는 당사가 임차인을 보호하기 위해 운영하는
                차량손해면책(자차보험)계약제도 중 하나 를 선택하여 계약할 수
                있습니다.
                <br />
              </S.Text>
            </S.Section>
            <S.Section type='text'>
              <S.Text type='main'>
                • 차량손해면책(자차보험)계약제도 임차인이 렌트카를 임차 시점부터
                회사에 반환하는 시점까지 선량한 관리자의 주의의무를 다하여
                렌트카를 사용하고 보관하며, 제반교통법규를 성실히 준수하여
                이용하는 조건하에 당사와 임차인이 체결하는 계약제도이며,
                임차인이 사고 발생 시 임차차량 수리비용에 대해 계약 내용에서
                정한 일정 부분을 면책받는 제도입니다.
                <br />
              </S.Text>
            </S.Section>
            <S.Section type='text'>
              <S.Text type='main'>
                - 차량손해면책 계약은 반드시 내용 및 제외 항목 등 을 충분히
                숙지하고 가입하여야 합니다. <br />
                - 차량손해면책 요금은 총 대여일수로 산출하고 1회 소멸성으로
                적용합니다. (예, 2박3일 : 3일적용, 임차기간 중 일부기간만 가입은
                불가합니다.) <br />
                - 차량 임차 이후에 유선상으로 손해면책 계약 유형 변경은
                불가하며, 계약 유형 변경은 본사 방문 후 가능합니다.
                <br />
              </S.Text>
            </S.Section>
          </S.Section>
          <S.TableWrapper>
            <S.Table>
              <thead>
                <S.TableRow height='51px'>
                  <S.Th>자차보험 미계약</S.Th>
                </S.TableRow>
              </thead>
              <tbody>
                <S.TableRow>
                  <S.Td>
                    사고 발생 시, 수리비 전액 + 휴차보상료 + 견인 비용 등 <br />
                    전액을 임차인이 부담
                  </S.Td>
                </S.TableRow>
              </tbody>
            </S.Table>
          </S.TableWrapper>
          <S.TableWrapper>
            <S.Table>
              <thead>
                <S.TableRow height='51px'>
                  <S.Th>일반면책(일반자차) 계약</S.Th>
                </S.TableRow>
              </thead>
              <tbody>
                <S.TableRow>
                  <S.Td>
                    • 보상한도 이하 사고 시, 면책금(수리비의 20%/최저 20만
                    원~최고 100만 원) 및 휴차보상료 임차인 부담
                    <br />• 보상한도 초과 사고 시, 면책금 50만 원 및 휴차보상료,
                    한도 초과분 임차인 부담
                  </S.Td>
                </S.TableRow>
              </tbody>
            </S.Table>
          </S.TableWrapper>
          <S.TableWrapper>
            <S.Table>
              <thead>
                <S.TableRow height='51px'>
                  <S.Th>고급면책(고급자차) 계약</S.Th>
                </S.TableRow>
              </thead>
              <tbody>
                <S.TableRow>
                  <S.Td>
                    • 보상한도 이하 사고 시, 임차인 부담 없음
                    <br />• 보상한도 초과 사고 시, 한도 초과분, 휴차보상료
                    임차인 부담
                  </S.Td>
                </S.TableRow>
              </tbody>
            </S.Table>
          </S.TableWrapper>

          <S.Section type='text'>
            <S.Text type='main' fontWeight={600}>
              ★휴차보상료
              <br />
            </S.Text>
            <S.Text type='main'>
              * 사고 발생 후 수리하는 기간동안 차량 운행을 못하여 발생하는
              영업손실금
              <br />* 1일 대여료의 50% X 수리일자
            </S.Text>
          </S.Section>

          <S.Section type='main'>
            <S.Title type='reservation'>
              [차량 손해 면책(자차차보험) 계약 제도 제외 항목]
            </S.Title>

            <S.Section type='paragraph'>
              <S.Title type='section'>1. 당사 미 통보 사고</S.Title>
              <S.Section type='text'>
                <S.Text type='main'>
                  ※ 단독사고(경미한 파손 및 훼손 포함) 및 차 대 차사고 발생 시
                  즉시 현장에서 당사로 통보해야 합니다.
                  <br />- 차량 반납 이후 다음 임차인에게 대여되는 차량이므로
                  당사로 통보되지 않을 시 원활한 예약 및 출고에 많은 제약 상황이
                  발생합니다. <br />
                </S.Text>
                <S.Text type='highlight'>
                  - 당사로 통보되지 않을 시 자차보험 처리 불가 및 패널티 10만 원
                  부과
                </S.Text>
              </S.Section>
            </S.Section>

            <S.Section type='paragraph'>
              <S.Title type='section'>2. 최초 사고 1건을 초과하는 사고</S.Title>
              <S.Section type='text'>
                <S.Text type='main'>
                  ※ 차량손해면책(자차보험)제도는 1회 소멸성 보험이므로, 최초
                  사고 1건 발생 시 자동 소멸됩니다.
                  <br />- 단독사고 및 차 대 차사고 발생 시 차량손해 면책계약은
                  자동 해지 됩니다. <br />
                  ** 추가 사고 발생 시 전액 고객 부담
                </S.Text>
              </S.Section>
            </S.Section>

            <S.Section type='paragraph'>
              <S.Title type='section'>
                3. 명백한 교통법규 위반 사고(음주운전, 신호 위반, 불법 유턴,
                중앙선 침범 등)
              </S.Title>
            </S.Section>

            <S.Section type='paragraph'>
              <S.Title type='section'>4. 소모품</S.Title>
              <S.Section type='text'>
                <S.Text type='main'>
                  * 타이어, 휠, 키 분실 및 훼손, 네비게이션, 실내부품 등
                  <br />- 수입 차량은 키 분실 및 훼손 시 500,000원 +
                  휴차보상료*30일
                </S.Text>
              </S.Section>
            </S.Section>

            <S.Section type='paragraph'>
              <S.Title type='section'>
                5. 임차인 부주의로 인한 출동 및 견인, 구난
              </S.Title>
              <S.Section type='text'>
                <S.Text type='main'>
                  - 타이어 펑크 또는 파스, 배터리 방전, 사고 후 운행 불가 상태
                </S.Text>
              </S.Section>
            </S.Section>

            <S.Section type='paragraph'>
              <S.Title type='section'>6. 혼유사고</S.Title>
              <S.Section type='text'>
                <S.Text type='main'>- 유종이 다른 연료를 주입한 경우</S.Text>
              </S.Section>
            </S.Section>

            <S.Section type='paragraph'>
              <S.Title type='section'>
                7. 제주 본섬 외 지역 무단반출 후 사고
              </S.Title>
            </S.Section>

            <S.Section type='paragraph'>
              <S.Title type='section'>
                8. 전기 차량 주 배터리 충전 혹은 사고로 인한 파손, 무리한
                조작으로 인한 충전기 삽입구 파손 및 훼손
              </S.Title>
              <S.Section type='text'>
                <S.Text type='main'>
                  - 과열 상태의 배터리 충전 혹은 사고로 인한 파손
                  <br />- 무리한 조작으로 인한 충전기 상입구 파손 및 훼손
                </S.Text>
              </S.Section>
            </S.Section>

            <S.Section type='paragraph'>
              <S.Title type='section'>
                9. 태풍, 폭우, 폭설 등 자연 재해 속에서 무리한 운전으로 인한
                차량 훼손
              </S.Title>
              <S.Section type='text'>
                <S.Text type='main'>
                  - 폭우 중 침수지역 주행으로 인한 엔진 침수 <br />- 폭설 중
                  통제된 도로 진입 후 사고 등
                </S.Text>
              </S.Section>
            </S.Section>

            <S.Section type='paragraph'>
              <S.Title type='section'>
                10. 차량 높이가 제한된 도로, 건물, 주차장 등에 진입 중 발생한
                차량 지붕 사고 (종합 보험 접수도 불가)
              </S.Title>
            </S.Section>

            <S.Section type='main'>
              <S.Section type='paragraph'>
                <S.Title type='section'>
                  ※ 차량손해면책(자차보험)보상한도 보상한도 무제한&현장출동 특약
                </S.Title>
                <S.Section type='text'>
                  <S.Text type='main'>
                    • 보상한도 무제한&현장출동 특약은 선량한 운전자(임차인)에
                    안전운행을 전제로 당사에서 시행하는 제도 입니다. <br />
                    • 보상한도 무제한&현장출동 특약 가입 시, 보상한도 무제한,
                    타이어, 휠, 소모품, 긴급출동 서비스 1회 보장(단, 견인은
                    10km까지 무상) <br />• 최대 7일 / 1일 1만원
                  </S.Text>
                </S.Section>
              </S.Section>

              <S.Section type='paragraph'>
                <S.Title type='section'>
                  ※ 차량손해면책(자차보험) 현장출동 특약
                </S.Title>
                <S.Section type='text'>
                  <S.Text type='main'>
                    • 현장 출동 특약 가입 시, 타이어, 휠, 소모품, 긴급출동
                    서비스 1회 보장(단, 견인은 10km까지 무상) <br />•
                    이용기간동안 가입 비용 2박 3일 기준 1만원
                  </S.Text>
                </S.Section>
              </S.Section>

              <S.Section type='paragraph'>
                <S.Title type='section'>
                  ※ 특약{' '}
                  <S.Text type='highlight' fontWeight={600} fontSize='18px'>
                    가입 불가{' '}
                  </S.Text>
                  차종
                </S.Title>
                <S.Section type='text'>
                  <S.Text type='highlight'>
                    • 제네시스 시리즈, 쏠라티, 수입 차량 가입 불가
                  </S.Text>
                </S.Section>
              </S.Section>

              <S.Section type='paragraph'>
                <S.Title type='section'>
                  ※ 무제한 특약 및 제외 항목 특약{' '}
                  <S.Text type='highlight' fontWeight={600} fontSize='18px'>
                    적용 불가 항목
                  </S.Text>
                </S.Title>
                <S.Section type='text'>
                  <S.Text type='highlight'>
                    ★ 구난 작업 및 겨울철 결빙으로 인한 출동은 제외 <br />
                    ★ 키 분실 시, 분실 비용에 대해서는 비용이 발생하지 않으나,
                    보조키를 보낼 때 발생하는 택시 비용은 고객이 부담 <br />
                    ★ 일반 및 고급자차와 마찬가지로 명백한 교통법규
                    위반사고(음주운전, 신호위반, 불법유턴, 보도침범, 앞지르기
                    등)로 인한 사고 처리 불가 <br />
                    ★ 섬 지역에서의 사고(우도, 마라도 등) 및 제주도 이외
                    지역으로 무단반출 후 사고 처리 불가 <br />
                    ★ 유종이 다른 연료를 주입한 혼유 사고 <br />
                    ★ 전기 차량 주 배터리 충전 혹은 사고로 인한 파손, 무리한
                    조작으로 인한 충전기 삽입구 파손 및 훼손 <br />★ 태풍, 폭우,
                    폭설 등 자연 재해 속에서 무리한 운전으로 인한 차량 훼손
                    <br />★ 차량 높이가 제한된 도로, 건물, 주차장 등에 진입 중
                    발생한 차량 지붕 사고(종합 보험 접수도 불가)
                  </S.Text>
                </S.Section>
              </S.Section>
            </S.Section>
          </S.Section>
        </S.Wrapper>
      )}
    </>
  );
};

export default InsuranceInfo;
